import { useState } from 'owa-react';
import React from 'react';
import { createRoot } from 'react-dom/client';
/* eslint-disable-next-line @fluentui/react-components/prefer-fluentui-v9 -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE! Substitute this line with an explanation or resolve the problem by using v9 components instead
 *	> Avoid importing Dialog from '@fluentui/react', as this package has started migration to Fluent UI 9. Import Dialog from '@fluentui/react-components' instead. */
import { Dialog, DialogFooter } from '@fluentui/react/lib/Dialog';
import { FluentButton } from 'owa-fluent-v9-shims';

export default function showWebapplinkTestDialog(): void {
    let container = document.getElementById('webapplinkTestDialogContainer');
    if (!container) {
        container = document.createElement('div');
        container.id = 'webapplinkTestDialogContainer';
        window.document.body.appendChild(container);
    }
    const root = createRoot(container);

    root.render(<WebapplinkTestDialog root={root} container={container} />);
}

export interface WebapplinkTestDialogProps {
    root: ReturnType<typeof createRoot>;
    container: HTMLElement;
}
function WebapplinkTestDialog({ root, container }: WebapplinkTestDialogProps) {
    const [showDialog, setShowDialog] = useState(true);

    const dismissDialog = React.useCallback(() => {
        setShowDialog(false);
    }, []);

    React.useEffect(() => {
        if (!showDialog) {
            root.unmount();
            container.remove();
        }
    }, [showDialog, root, container]);

    return (
        <Dialog isClickableOutsideFocusTrap={true} hidden={!showDialog} minWidth={'350px'}>
            <span>{"You've successfully launched the WebAppLink Test Page!"}</span>
            <DialogFooter>
                <FluentButton appearance="primary" onClick={dismissDialog} text={'OK'} />
            </DialogFooter>
        </Dialog>
    );
}
